<div class="mt-6">
  <nz-input-group [nzSuffix]="suffixIconSearch" class="bosch_input">
    <input type="text" nz-input [placeholder]="'ADDRESS_SEARCH'|translate" (keydown.enter)="handleSearchByAddress()"
      [(ngModel)]="address" />
  </nz-input-group>
  <ng-template #suffixIconSearch>
    <div class="cursor-pointer" (click)="onClear()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M16.6474 6.64795L17.3524 7.35295L12.7139 11.9999L17.3534 16.6469L16.6484 17.3519L12.0014 12.7124L7.35344 17.3519L6.64844 16.648L11.2889 11.9999L6.64944 7.35195L7.35344 6.64795L12.0014 11.2874L16.6474 6.64795Z"
          fill="black" />
      </svg>
    </div>
    <div class="cursor-pointer ml-[24px]" (click)="handleSearchByAddress()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M21.35 18.65L14.25 11.5375C14.7375 10.625 15 9.6 15 8.5C15 4.9125 12.0875 2 8.5 2C4.9125 2 2 4.9125 2 8.5C2 12.0875 4.9125 15 8.5 15C9.6 15 10.625 14.725 11.5375 14.25L18.65 21.3625C19.0875 21.8 19.6375 22.0125 20.175 22.0125C20.6625 22.0125 21.125 21.8375 21.475 21.4875C22.225 20.7375 22.175 19.4625 21.35 18.65ZM3 8.5C3 5.4625 5.4625 3 8.5 3C11.5375 3 14 5.4625 14 8.5C14 11.5375 11.5375 14 8.5 14C5.4625 14 3 11.5375 3 8.5ZM20.775 20.775C20.55 21 20.2875 21.025 20.1125 21.0125C19.8375 20.9875 19.5625 20.8625 19.3625 20.65L12.4125 13.7C12.9 13.3375 13.3375 12.9 13.7 12.4125L20.65 19.3625C20.85 19.5625 20.9875 19.8375 21.0125 20.1125C21.0125 20.2875 20.9875 20.55 20.775 20.775Z"
          fill="black" />
      </svg>
    </div>


  </ng-template>
  <div class="address-wrap sm:w-full md:w-full lx:w-[1012px]">
    <div class="pt-6 flex flex-wrap gap-6 w-full">
      <div class="address-item sm:w-full mx:w-[320px] flex-none" *ngFor="let address of sortAddressesByDefault(searchResults); let i = index;">
        <div class="address flex">
          <div class="mt20">
            <svg-icon class="cursor-pointer" [iconName]="'un-choose.svg'" *ngIf="!address.isChoose"
              (click)="chooseAddress(address,true)"></svg-icon>
            <svg-icon class="cursor-pointer" [iconName]="'choosed.svg'" *ngIf="address.isChoose"
              (click)="chooseAddress(address,false)"></svg-icon>
          </div>
          <div class="address-info">
            <div class="default" *ngIf="address.userDefault">{{'DEFAULT_SHIPPING_ADDRESS'|translate}}</div>
            <div class="truncate font-bold" [ngClass]="{'mt-1':address.userDefault}" [attr.title]="address.customerName">{{address.customerName}}</div>
            <div class="truncate mt-1" [attr.title]="address.street">{{address.street}}</div>
            <div class=" mt-1">{{address.postalCode}} {{address.city}}</div>
            <div class=" mt-1">{{address.country}} {{address.region}}</div>
            <div class=" mt-1">{{address.mobilePhone}}</div>
            <div class=" mt-1">{{address.customerCode}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="flex justify-between pb-8 flex-wrap">
    <div class="cursor-pointer flex-v-center mr-2" (click)="goAddress()">
      <svg-icon [iconName]="'new/address-book.svg'" class="mr-2"></svg-icon>
      <span class="text-primaryBlue">{{'DEFAULT_ADDRESS' |translate}}</span>
    </div>
    <div class="flex sm:mt-4">
      <div class="primary-small-btn mr-4 sm:w-[156px]" (click)="saveAddress()">
        <span> {{'CONFIRM'|translate}}</span>
      </div>
      <div class="default-small-btn sm:w-[156px]" (click)="closeModal()">
        <span> {{'CLOSE'|translate}}</span>
      </div>
    </div>
  </div>
</div>